window.addEventListener("load",function(){
  // START GALLERY
  const galleryContainer = document.querySelector('.hotel-imgs');
  if(galleryContainer) {
    let activeSlide = 1;
    let thumbsShowing = 2;
    let trackOffset = 0;
    let galleryTrack = galleryContainer.querySelector('.hotel-img-track');
    let mainImg = galleryContainer.querySelector('.hotel-img-main > img');
    let totalSlides = galleryTrack.childElementCount;
    let mainHeight = mainImg.clientHeight;
    let thumbHeight = galleryContainer.querySelector('.hotel-img-side > div > div:first-of-type').offsetHeight;

    function galleryInit() {
      activeSlide = 1;
      mainHeight = mainImg.clientHeight;
      thumbHeight = galleryContainer.querySelector('.hotel-img-side > div > div:first-of-type').offsetHeight;
      galleryContainer.style.maxHeight = mainHeight+'px';
      galleryTrack.style.transform = 'translate(0, 0)';
    }
    window.addEventListener("resize", galleryInit);
    window.addEventListener("orientationchange", galleryInit);
    galleryInit();

    // Next Slide
    document.querySelector('#hotel-slide-next').addEventListener('click', () => {
      if(totalSlides > 2 && activeSlide < (totalSlides-(thumbsShowing/2))){
        (activeSlide === 1) ? trackOffset = thumbHeight : trackOffset = thumbHeight*activeSlide;
        galleryTrack.style.transform = 'translate(0, -'+trackOffset+'px)';
        activeSlide++;
      }
    });

    // Previous Slide
    document.querySelector('#hotel-slide-prev').addEventListener('click', () => {
      if(totalSlides > 2 && activeSlide > (thumbsShowing/2)){
        activeSlide--;
        trackOffset = (thumbHeight*activeSlide) - thumbHeight;
        galleryTrack.style.transform = 'translate(0, -'+trackOffset+'px)';
      }
    });

    // Update main img
    document.querySelectorAll('.hotel-img-side > div > div').forEach((value) => {
      value.addEventListener('click', (val) => {
        mainImg.src = val.target.dataset.srcFull;
      })
    })
  }
  // END GALLERY

  // LOAD VIDEO BG
  const bgv = document.getElementById("bgvid");
  const visible = bgv.offsetWidth || bgv.offsetHeight || bgv.getClientRects().length;
  if (bgv){
    if (visible) {
      const children = bgv.getElementsByTagName("source");
      for (let i = 0; i < children.length; ++i) {
        children[i].src = children[i].dataset.src;
      }
    }
    bgv.load();
  }

}, false);


document.addEventListener("DOMContentLoaded", function() {

  // Resort Slider
  const resortSlider = [].slice.call(document.querySelectorAll('.resort-section .resort-slider'))
  if (resortSlider) {
    resortSlider.forEach((e) => {
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        dots: '.resort-section .dots',
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.resort-section .glider-prev',
          next: '.resort-section .glider-next'
        },
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
      })
    })
  }
  // END Resort Slider

})